import { render, staticRenderFns } from "./SelectMesa.vue?vue&type=template&id=51d6c5ea&"
import script from "./SelectMesa.vue?vue&type=script&lang=js&"
export * from "./SelectMesa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports